<app-loader *ngIf="isDisabled"></app-loader>
<div class="row">
  <div class="col">
    <div class="greet">
      <h1 class="text-secondary-500 pb-1.5x">{{greeting}}</h1>
    </div>
  </div>
  <div class="col-auto">
    <button class="btn btn-sm btn-primary" name="cancel" [routerLink]="['/myteam']">
      <!-- <i class="bi bi-download" *ngIf="!isDisabled"></i> -->
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
      {{!isDisabled?'My Team':'Loading...'}}
    </button>
  </div>
</div>


<div>
  <div class="row my-1 g-1">
    <div class="col-md-4">
      <div class="card h-100 m-0">
        <div class="card-body p-1">
          <div class="row">
            <label class="form-label"
              style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;text-align: -webkit-center;">Online
              Attendance</label>
          </div>
          <div class="row">
            <label class="form-label"
              style="font-size: 25px!important;font-weight: 500; margin-bottom: 5px;text-align: -webkit-center;">{{Duration}}</label>
          </div>
          <div style="background-color:#80808036;border-radius: 5px;" class="p-2 mb-2">
            <div class="row">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Branch</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.BranchName}}</label>
              </div>
            </div>
            <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Site</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.SiteName}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.DesignationName}}</label>
              </div>
            </div>
            <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Duty</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.DutyName}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Shift</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.ShiftTitle}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">In
                  Date Time</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.InTime??''
                  | date: 'dd-MMM-yyyy H:mm:ss'}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Out
                  Date Time</label>
              </div>
              <div class="col-auto">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.OutTime??''
                  | date: 'dd-MMM-yyyy H:mm:ss'}}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 d-grid" *ngIf="!isDisabled">
              <button class="btn btn-primary"
                *ngIf="isShowAttendaceBtn && !AttendanceDetail.IsCheckIn && !AttendanceDetail.IsAttendaceClose"
                mat-raised-button color="primary" type="button" (click)="GetDateTime(true)"
                [disabled]="AttendanceDetail.IsAttendaceClose || isDisabled"><i
                  class="bi bi-box-arrow-in-right me-2"></i>Check
                In</button>
              <button class="btn btn-danger"
                *ngIf="isShowAttendaceBtn && AttendanceDetail.IsCheckIn && !AttendanceDetail.IsAttendaceClose"
                mat-raised-button color="warn" type="button" (click)="GetDateTime(true)"
                [disabled]="AttendanceDetail.IsAttendaceClose || isDisabled"><i
                  class="bi bi-box-arrow-in-left me-2"></i>Check Out</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div class="card h-100 m-0">
        <div class="card-body p-1">
          <div class="row" style="place-content:center">
            <div class="col-auto">
              <ngb-datepicker #dp [(ngModel)]="filter.AttendanceDate" (navigate)="onNavigate($event)"
                [dayTemplate]="customDay" (dateSelect)="CalenderDateSelect($event)"></ngb-datepicker>
              <ng-template #customDay ngbdatepickerdayview let-date="date" let-currentMonth="currentMonth"
                let-selected="selected" let-disabled="disabled">
                <div class="day-container" style="text-align: center;
                width: 2rem;
                height: 2rem;
                line-height: 2rem;
                border-radius: .25rem;
                background: transparent;">
                  <span class="custom-day" [class.faded]="date.month !== currentMonth" [class.selected]="selected"
                    [class.disabled]="disabled" [ngStyle]="getDayStyle(date)">
                    {{ date.day }}
                  </span>
                  <div class="dot" [ngStyle]="getDayDotStyle(date)"></div>
                  <div class="dot2" [ngStyle]="getDayDotStyle2(date)"></div>
                  <!-- New dot element -->
                </div>
              </ng-template>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-md-7">
                  <div class="row" style="align-items: center;line-height: normal;">
                    <div class="col-3">
                      <img *ngIf="CalendarDetailsData.Photo != null && CalendarDetailsData.Photo != ''" mat-card-image
                        class="userImage" [src]="common.PhotoLink(CalendarDetailsData.Photo)" />
                      <div *ngIf="CalendarDetailsData.Photo == null || CalendarDetailsData.Photo == ''"
                        class="initial-image">
                        <div class="image">
                          {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                        </div>
                      </div>
                    </div>
                    <div class="col-9 userdetail">
                      <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{CalendarDetailsData.EmployeeName}}</label><br />
                      <label class="form-label"
                        style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{CalendarDetailsData.EmpCode}}</label><br />
                      <label class="form-label"
                        style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{CalendarDetailsData.DesignationName}}</label>
                    </div>
                  </div>
                </div>
                <div class="col"></div>
                <div class="col-md-4">
                  <label for="RequestDate" class="text-label-light">Attendance Date</label> <br />
                  <label name="RequestDate" class="text-label-dark">{{CalendarDetailsData.AttendanceDate!=
                    null?this.dateFromat.format(CalendarDetailsData.AttendanceDate):''}}</label>
                </div>
              </div>
              <div style="background-color:#0078d42e;border-radius: 5px;" class="p-1 mb-2">
                <div class="row align-items-center">
                  <div class="col-md-5">
                    <div class="row align-items-center">
                      <div class="col-3">
                        <img
                          *ngIf="CalendarDetailsData.DailyAttendancePhoto != null && CalendarDetailsData.DailyAttendancePhoto != ''"
                          mat-card-image class="userImage" [src]="CalendarDetailsData.DailyAttendancePhoto"
                          (click)="common.FullImage(CalendarDetailsData.DailyAttendancePhoto,{ProfileImage:common.PhotoLink(CalendarDetailsData.Photo),Name:CalendarDetailsData.EmployeeName,Code:CalendarDetailsData.EmpCode??'',Designation:CalendarDetailsData.DesignationName??''} )" />
                        <div
                          *ngIf="CalendarDetailsData.DailyAttendancePhoto == null || CalendarDetailsData.DailyAttendancePhoto == ''"
                          class="initial-image">
                          <div class="image">
                            {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <label for="InTime" class="text-label-light">In Time</label> <br />
                        <label name="InTime" style="font-size: 0.8rem;" class="text-label-dark"
                          *ngIf="CalendarDetailsData.InTime != null">{{CalendarDetailsData.InTime | date : 'dd MMM yyyy'}}</label>
                        <br />
                        <label name="InTime" style="font-size: 0.8rem;" class="text-label-dark"
                          *ngIf="CalendarDetailsData.InTime != null">{{CalendarDetailsData.InTime | date : 'HH:mm:ss'}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="row align-items-center">
                      <div class="col-3">
                        <img
                          *ngIf="CalendarDetailsData.DailyAttendancePhotoOut != null && CalendarDetailsData.DailyAttendancePhotoOut != ''"
                          mat-card-image class="userImage" [src]="CalendarDetailsData.DailyAttendancePhotoOut"
                          (click)="common.FullImage(CalendarDetailsData.DailyAttendancePhotoOut,{ProfileImage:common.PhotoLink(CalendarDetailsData.Photo),Name:CalendarDetailsData.EmployeeName,Code:CalendarDetailsData.EmpCode??'',Designation:CalendarDetailsData.DesignationName??''} )" />
                        <div
                          *ngIf="CalendarDetailsData.DailyAttendancePhotoOut == null || CalendarDetailsData.DailyAttendancePhotoOut == ''"
                          class="initial-image">
                          <div class="image">
                            {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <label for="OutTime" class="text-label-light">Out Time</label> <br />
                        <label name="OutTime" style="font-size: 0.8rem;" class="text-label-dark"
                          *ngIf="CalendarDetailsData.OutTime != null">{{CalendarDetailsData.OutTime | date : 'dd MMM yyyy'}}</label>
                        <br />
                        <label name="OutTime" style="font-size: 0.8rem;" class="text-label-dark"
                          *ngIf="CalendarDetailsData.OutTime != null">{{CalendarDetailsData.OutTime | date :
                          'HH:mm:ss'}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div
                      *ngIf="calculateTotalDuration(CalendarDetailsData.InTime | date : 'HH:mm:ss', CalendarDetailsData.OutTime | date : 'HH:mm:ss') !== ''"
                      style="background: linear-gradient(to right, #338AF3, #4B65DF); color: white; border-radius: 10px;">
                      <p class="pt-1" style="font-size: 0.8rem; font-weight: bold; text-align: center; margin: auto">
                        {{calculateTotalDuration(CalendarDetailsData.InTime | date : 'HH:mm:ss',
                        CalendarDetailsData.OutTime | date : 'HH:mm:ss') }}
                      </p>
                      <p class="p-1" style="font-size: 0.7rem; text-align: center; margin: auto;">Total Hours</p>
                    </div>
                  </div>
                  <div class="col-md-12"
                    *ngIf="CalendarDetailsData.InTime == null && CalendarDetailsData.OutTime == null"
                    style="text-align: -webkit-center">
                    <label class="text-label-light" style="font-weight: 500;">Attendance Not Punch</label>
                  </div>
                </div>
              </div>

              <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                <div class="row">
                  <div class="col-4">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
                  </div>
                  <div class="col">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.DesignationName}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Shift</label>
                  </div>
                  <div class="col">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.ShiftTitle}}</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-4">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">In
                      Reason</label>
                  </div>
                  <div class="col">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.InReason}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Out
                      Reason</label>
                  </div>
                  <div class="col">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.OutReason}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Type</label>
                  </div>
                  <div class="col">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.AttendanceDescription}}</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-4">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Remark</label>
                  </div>
                  <div class="col">
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.Remark}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-auto" *ngFor="let cDSummary of calendarDataSummary;let i=index">
              <span class="badge success" [ngStyle]="{'background-color': cDSummary.Colour}">{{cDSummary.Type}}
                ({{cDSummary.Count}})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row my-1 g-1">
    <div class="col-md-8">
      <div class="row g-1">
        <div class="col-md-6">
          <div class="card m-0" style="height: 17rem">
            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div class="card-title m-0">
                    <div class="card-title m-0"><img src="../../../assets/wallet.png" width="30px"
                        class="me-1" />Payslip</div>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="col-auto" style="font-size:large; font-weight: 400;"><span class="badge success"
                      style="background-color: var(--primary); border-radius: 15%;">{{PaySlipData.length}}</span></div>
                </div>
              </div>
            </div>
            <div class="card-body card-body py-1 px-3" style="overflow-x: hidden;">
              <div class="row">
                <div class="col-md-4 p-1" *ngFor="let data of PaySlipData;let i=index"
                  (click)="GeneratePaySlip(data.MonthName ,data.YearName)">
                  <div class="card border" [ngClass]="data.MonthName">
                    <div class="card-body p-2">
                      <div class="row">
                        <div class="col-12 text-center"><i class="bi bi-file-earmark-text"></i></div>
                        <div class="col-12 text-center">
                          <label class="form-label"
                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{data.MonthName}}</label>
                        </div>
                        <div class="col-12 text-center">
                          <label class="form-label"
                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{data.YearName}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- <div class="row" *ngFor="let data of PaySlipData;let i=index">
                <div class="col">
                  <label class="form-label"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{data.MonthName}}
                    {{data.YearName}}</label>
                </div>
                <div class="col-auto">
                  <i class="bi bi-file-earmark-text" (click)="GeneratePaySlip(data.MonthName ,data.YearName)"
                    id="{{i+1}}-{{data.MonthName}}-{{data.YearName}}"></i>
                </div>
              </div> -->
              <label class="month" *ngIf="PaySlipData.length == 0">Payslip Not Available</label>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card m-0" style="height: 17rem;">
            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div class="card-title m-0">
                    <div class="card-title m-0"><img src="../../../assets/leave.png" width="30px" class="me-1" />Leave
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="col-auto" style="font-size:large; font-weight: 400;"><span class="badge success"
                      style="background-color: var(--primary); border-radius: 15%;">{{LeaveSum()}}</span></div>
                </div>
              </div>
            </div>
            <div class="card-body p-2" style="overflow-x: hidden;overflow-y: auto;">
              <div class="row" *ngFor="let LeaveType of LeaveTypes;let i=index" [routerLink]="['/request/leave']">
                <div class="col">
                  <label class="form-label cursor-pointer"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{LeaveType.LeaveName}}</label>
                </div>
                <div class="col-auto">
                  <label class="form-label cursor-pointer"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{LeaveType.LeaveOB}}</label>
                </div>
              </div>
              <div class="row" [routerLink]="['/request/compensatoryoffconsume']">
                <div class="col">
                  <label class="form-label cursor-pointer"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">CO</label>
                </div>
                <div class="col-auto">
                  <label class="form-label cursor-pointer"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CompOffCount}}</label>
                </div>
              </div>
              <label class="month" *ngIf="LeaveTypes.length == 0 && CompOffTable.length == 0">Leave Not
                Available</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-1 mt-1">
        <div class="col-md-6">
          <div class="card m-0" style="height: 17rem">
            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div class="card-title m-0">
                    <div class="card-title m-0"><img src="../../../assets/calendar.png" width="30px"
                        class="me-1" />Holidays</div>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="col-auto" style="font-size:large; font-weight: 400;"><span class="badge success"
                      style="background-color: var(--primary); border-radius: 15%;">{{Holidays.length}}</span></div>
                </div>
              </div>
            </div>
            <div class="card-body p-2" style="overflow-x: hidden;overflow-y: auto;">
              <div class="row" *ngFor="let Holiday of Holidays;let i=index">
                <div class="col-8">
                  <label [routerLink]="['/holidaylist']" class="form-label cursor-pointer"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{Holiday.HolidayName}}</label>
                </div>
                <div class="col-4">
                  <label [routerLink]="['/holidaylist']" class="form-label cursor-pointer"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{Holiday.Date
                    | date : 'dd MMM yyyy'}}</label>
                </div>
              </div>
              <label class="month" *ngIf="Holidays.length == 0">Holiday Not Available</label>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card m-0" style="height: 17rem">
            <div class="card-header">
              <div class="row">
                <div class="col p-0">
                  <div class="card-title m-0"><img src="../../../assets/event.png" width="30px" class="me-1" />Birthday
                  </div>
                </div>
                <div class="col-auto">
                  <div class="col-auto" style="font-size:large; font-weight: 400;"><span class="badge success"
                      style="background-color: var(--primary); border-radius: 15%;">{{TodayBirthdayDetails.length}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body p-2" style="overflow-x: hidden;overflow-y: auto;">
              <div class="row mb-2" *ngFor="let tBirthday of TodayBirthdayDetails;let i=index">
                <div class="col pe-0">
                  <div class="row cursor-pointer">
                    <div class="col-3">
                      <img *ngIf="tBirthday.Photo != null && tBirthday.Photo != ''" mat-card-image class="userImage"
                        [src]="common.PhotoLink(tBirthday.Photo)" />
                      <div class="initial-image" *ngIf="tBirthday.Photo == null || tBirthday.Photo == ''">
                        <div class="image">
                          {{common.getInitial(tBirthday.FullName)}}
                        </div>
                      </div>
                    </div>
                    <div class=" col-8 userdetail">
                      <span class="text-label">{{tBirthday.FullName}}</span><br />
                      <span class="text-label-light">#{{tBirthday.EmpCode}}</span><br />
                      <span class="text-label-light">{{tBirthday.Birthdate}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-auto p-0">
                  <img src="../../../assets/birthday-cake.png" width="30px" />
                </div>
                <div class="col-auto">
                  <div class="col-auto" style="font-size:large; font-weight: 400;"
                    *ngIf="tBirthday.IsBirthdayToday == 1"><span class="badge success"
                      style="border-radius: 5%;">Today</span></div>
                  <div class="col-auto" style="font-size:large; font-weight: 400;"
                    *ngIf="tBirthday.IsBirthdayToday == 0"><span class="badge warning"
                      style="border-radius: 5%;">Upcoming</span></div>
                </div>
              </div>
              <label class="month" *ngIf="TodayBirthdayDetails.length == 0">Birthday Not Available</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card m-0" style="height: 34.8rem;">
        <div class="card-header">
          <div class="row">
            <div class="col p-0">
              <div class="card-title m-0"><img src="../../../assets/feed-back.png" width="30px" class="me-1" />Feeds
              </div>
            </div>
            <div class="col-auto">
              <div class="col-auto" style="font-size:large; font-weight: 400;"><span class="badge success"
                  style="background-color: var(--primary); border-radius: 15%;">{{FeedDetails.length}}</span></div>
            </div>
          </div>
        </div>
        <div class="card-body p-0" style="overflow-x: hidden;overflow-y: auto;">
          <div class="card my-1" *ngFor="let feedItems of FeedDetails; let i = index">
            <div class="card-body p-1">
              <div class="row py-1">
                <div class="col">
                  <label class="form-label"
                    style="font-size: 13px!important;font-weight: 400; margin-bottom: 5px">{{feedItems.Date | date : 'dd
                    MMM yyyy'}}&nbsp;&nbsp;{{feedItems.CreatedTime}}</label>
                </div>
                <div class="col-auto">
                  <label class="form-label"
                    style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px">{{feedItems.PostingTo}}</label>
                </div>
              </div>
              <div class="row py-1 cursor-pointer">
                <div class="col-2">
                  <div class="initial-image">
                    <div class="image">
                      {{common.getInitial(feedItems.EmployeeName)}}
                    </div>
                  </div>
                </div>
                <div class="col-10 userdetail">
                  <span class="text-label">{{feedItems.EmployeeName}}</span><br />
                  <span class="text-label-light">#{{feedItems.EmpCode}}</span><br />
                </div>
              </div>
              <div class="row py-1">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px">{{feedItems.Title}}</label>
              </div>
              <div style="background-color:#80808036;border-radius: 5px;" class="p-2 mb-2">
                <label class="form-label"
                  style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{feedItems.Description}}</label>
              </div>
            </div>
            <div class="card-footer text-muted" style="position:relative">
              <div class="row">
                <div class="col-md" *ngIf="feedItems.EnableLike">
                  <button type="button" style="width: 100%;" class="btn btn-outline-primary btn-sm"
                    (click)="LikePost(feedItems.ESS_PostMasterID)"><img src="../../../assets/like (1).png" class="me-1">
                    Like - {{feedItems.LikeCount}}</button>
                </div>
                <div class="col-md" *ngIf="feedItems.EnableComment">
                  <button type="button" style="width: 100%;" class="btn btn-outline-primary btn-sm"
                    (click)=" toggleCommentSection(i,feedItems.ESS_PostMasterID)"><img
                      src="../../../assets/comments.png" class="me-1"> Comment - {{feedItems.CommentCount}}</button>
                </div>
              </div>
              <div class="timeline-comment-box" *ngIf="commentSectionVisibleIndex === i">
                <div class="user"><img src="..\assets\UserProfileImage\EmpDefaultImage.jpg"> </div>
                <div class="input">
                  <form action="">
                    <div class="input-group">
                      <input type="text" [(ngModel)]="Comment" class="form-control rounded-corner" name="Comment"
                        placeholder="Write a comment...">
                      <span class="input-group-btn p-l-10">
                        <button (click)="InsertCommentPost(feedItems.ESS_PostMasterID)"
                          class="btn btn-primary rounded-corner" type="button">Comment</button>
                      </span>
                    </div>
                  </form>
                </div>
                <div class="Comments py-1 row" *ngFor="let CommentData of Comments; let i = index">
                  <div style="background-color:white;border-radius: 5px;" class="p-2 mb-2">
                    <div class="row py-1 cursor-pointer">
                      <div class="col-2">
                        <div class="initial-image">
                          <div class="image">
                            {{common.getInitial(CommentData.UserName)}}
                          </div>
                        </div>
                      </div>
                      <div class="col-10 userdetail">
                        <span class="text-label">{{CommentData.UserName}}</span><br />
                        <span class="text-label-light">#{{CommentData.WhoComment}}</span><br />
                      </div>
                    </div>
                    <label class="form-label"
                      style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CommentData.Comment}}</label>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <label class="month" *ngIf="FeedDetails.length == 0">Feed Not Available</label>
        </div>
      </div>
    </div>
  </div>
</div>